import { useEffect, useMemo, useState } from 'react';
import { ICampaignPriority } from '../types/interfaces/CampaingTypes';
import { DropResult } from 'react-beautiful-dnd';
import { useSelector } from 'react-redux';

export const StepPriorityServiceComponent = ({ ...props }) => {
    const campaignService = props.campaignService;
    const {
        id,
        campaignDetail,
        setCampaignDetail,
        updatedCachedVersion,
        setUpdatedCacheVersion,
        saveCampaignForm,
        advanceToNextStep,
    } = campaignService;

    const liveCampaignStore = useSelector((state: any) => state.campaignLiveCampaign);

    const [priorities, setPriorities] = useState<ICampaignPriority[]>([]);

    const priorityList: ICampaignPriority[] = useMemo(() => {
        return priorities?.filter((x: any) =>
            liveCampaignStore.data === -1 ? x.status !== -1 : x.status === liveCampaignStore.data || x.id == id
        );
    }, [priorities, liveCampaignStore]);

    const getCampaignPriorities = async () => {
        let _priorities = campaignService.campaignDetail.priorities.map((x: any, index: number) => {
            return { ...x, rowNumber: ++index };
        });

        setPriorities(_priorities);
    };

    useEffect(() => {
        if (campaignDetail != undefined && campaignDetail.priorities != undefined) {
            getCampaignPriorities();
        }
    }, [campaignDetail]);

    const onDragEndPriority = async ({ destination, source }: DropResult) => {
        if (!destination) return;

        const reorderedList = Array.from(priorities);
        const sourceIndex = reorderedList.findIndex((x: ICampaignPriority) => x.rowNumber == source.index);
        const sourceItem: any = reorderedList[sourceIndex];
        reorderedList.splice(sourceIndex, 1);

        const destinationIndex = reorderedList.findIndex((x: ICampaignPriority) => x.rowNumber == destination.index);
        const startValue = destination.index > source.index ? destinationIndex + 1 : destinationIndex;
        reorderedList.splice(startValue, 0, sourceItem);

        reorderedList.map((priority: any, index: number) => {
            priority.rowNumber = ++index;
            priority.processOrder = ++index;
        });

        setPriorities(reorderedList);

        setCampaignDetail({
            ...campaignDetail,
            priorities: reorderedList,
        });

        setUpdatedCacheVersion({
            ...updatedCachedVersion,
            reloadAllCampaignRulePriority: true,
        });
    };

    const saveForm = async (event: any) => {
        event.preventDefault();

        const saveResult = await saveCampaignForm({});
        if (saveResult) {
            advanceToNextStep();
        }
    };

    return {
        ...campaignService,
        priorities,
        priorityList,
        onDragEndPriority,
        saveForm,
    };
};
